import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  variantA({ data }) {
    return {
      'Test Id': data.testId,
      'Variant Id': data.variantId,
      'Variant Distribution': data.variantDistribution,
      'Usage data': data.usageData,
      'Event type': data.eventType,
    };
  },
  variantB({ data }) {
    return {
      'Test Id': data.testId,
      'Variant Id': data.variantId,
      'Variant Distribution': data.variantDistribution,
      'Usage data': data.usageData,
      'Event type': data.eventType,
    };
  },
};

export default Transforms;
